import React from 'react';

const BotIcon = ({ className }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M8.25 3v1.5M4.5 8.25H3m18 0h-1.5M4.5 12H3m18 0h-1.5m-15 3.75H3m18 0h-1.5M8.25 19.5V21M12 3v1.5m0 15V21m3.75-18v1.5m0 15V21m-9-1.5h10.5a2.25 2.25 0 002.25-2.25V6.75a2.25 2.25 0 00-2.25-2.25H6.75A2.25 2.25 0 004.5 6.75v10.5a2.25 2.25 0 002.25 2.25zm.75-12h9v9h-9v-9z" /></svg>;

const ExpertCard = ({ expert, onEdit }) => {
    return (
        <div
            onClick={() => onEdit(expert)}
            className="group relative cursor-pointer h-full"
        >
            <div className="absolute -inset-px bg-gradient-to-b from-[var(--border-medium)] to-transparent rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

            <div className="relative h-full p-5 bg-[var(--bg-secondary)] dark:bg-[var(--bg-tertiary)]/20 backdrop-blur-sm border border-[var(--border-subtle)] rounded-xl shadow-sm group-hover:border-[var(--border-medium)] transition-all duration-300 overflow-hidden flex flex-col">

                {/* Top Actions: Settings Trigger (Redundant but keeps visual feedback) */}
                <div className="absolute top-0 right-0 p-3 flex gap-1.5 opacity-0 group-hover:opacity-100 transition-all duration-300 z-10">
                    <div className="p-1.5 rounded-md bg-white/5 text-[var(--text-muted)] group-hover:text-white transition-all">
                        <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" /><path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                    </div>
                </div>

                <div className="flex flex-col h-full space-y-3.5">
                    {/* Avatar / Icon */}
                    <div className="w-10 h-10 rounded-lg bg-[var(--text-main)] text-[var(--bg-main)] shadow-sm flex items-center justify-center shrink-0 transition-transform duration-500 group-hover:scale-105 overflow-hidden border border-[var(--border-subtle)]">
                        {expert.imageUrl ? (
                            <img src={expert.imageUrl} alt={expert.name} className="w-full h-full object-cover" />
                        ) : (
                            <BotIcon className="w-6 h-6" />
                        )}
                    </div>

                    <div className="space-y-1 pr-2">
                        <h3 className="text-[15px] font-medium text-[var(--text-main)] tracking-tight group-hover:text-[var(--accent-primary)] transition-colors line-clamp-1">
                            {expert.name}
                        </h3>
                        <p className="text-[12px] text-[var(--text-muted)] font-medium line-clamp-3 leading-relaxed min-h-[3rem]">
                            {expert.customInstructions || "Focused AI persona for specialized coordination and logic."}
                        </p>
                    </div>

                    <div className="mt-auto pt-3 flex items-center justify-between border-t border-[var(--border-subtle)] transition-colors">
                        <div className="flex items-center gap-1.5">
                            <div className="w-1 h-1 rounded-full bg-indigo-500/80" />
                            <span className="text-[9px] font-bold text-[var(--text-dim)] uppercase tracking-wider">Ready</span>
                        </div>
                        <span className="text-[9px] font-bold text-[var(--text-dim)] uppercase tracking-wider bg-[var(--bg-tertiary)]/50 px-1.5 py-0.5 rounded border border-[var(--border-subtle)]">
                            Agent
                        </span>
                    </div>
                </div>

                {/* Hover Highlight Overlay */}
                <div className="absolute inset-0 bg-gradient-to-tr from-[var(--accent-primary)]/[0.01] to-transparent pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>
        </div>
    );
};

export default ExpertCard;
